import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { Redirect, withRouter } from "react-router-dom";

import { MobileRegularPage, RepLIMobileStepper } from "../../../components";
import MobileLoading from "../../../components/MobileLoading";
import Page1 from "./Page1.component";
import Page2 from './Page2.component';
import Page3 from './Page3.component';
import Page4 from './Page4.component';
import Page5 from './Page5.component';
import Page6 from "./Page6.component";
import Page7 from "./Page7.component";
import Page8 from "./Page8.component";
import Page9 from "./Page9.component";
import Page10 from "./Page10.component";
import Page11 from "./Page11.component";
import Page12 from "./Page12.component";
import Page13 from "./Page13.component";

import { localStorageCleanup } from "../../../services/util.service";

import useStyles from "./Questionary.style";
import Cookies from 'universal-cookie';


const cookies = new Cookies();

const Questionary = props => {
    const classes = useStyles();

    const [loading, setLoading] = useState(true);
    const [activeStep, setActiveStep] = useState(0);
    const [exit, setExit] = useState(false);

    const [healthProfile, setHealthProfile] = useState();

    useEffect(() => {
        const getHealthProfile = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (!response) return;
                let json = await response.json();
                setHealthProfile(json);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            };
        };

        getHealthProfile();
    }, []);

    const steps = 13;

    const handleExitButtonClick = () => {
        localStorageCleanup();
        setExit(true);
    };

    const handleBackButtonClick = () => {
        if (activeStep === 0) return;
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    };

    const handleNextButtonClick = () => {
        if (activeStep === steps - 1) return;
        setActiveStep(prevActiveStep => prevActiveStep + 1);
    };

    const handleFinishButtonClick = async () => {
        props.history.push('/app/replisave');
    };

    if (loading) return <MobileLoading />

    if (exit) return <Redirect to="/app/dashboard" />

    return (
        <MobileRegularPage>
            {activeStep === 0 && <Page1 profile={healthProfile} />}
            {activeStep === 1 && <Page2 profile={healthProfile} />}
            {activeStep === 2 && <Page3 profile={healthProfile} />}
            {activeStep === 3 && <Page4 profile={healthProfile} />}
            {activeStep === 4 && <Page5 profile={healthProfile} />}
            {activeStep === 5 && <Page6 profile={healthProfile} />}
            {activeStep === 6 && <Page7 profile={healthProfile} />}
            {activeStep === 7 && <Page8 profile={healthProfile} />}
            {activeStep === 8 && <Page9 profile={healthProfile} />}
            {activeStep === 9 && <Page10 profile={healthProfile} />}
            {activeStep === 10 && <Page11 profile={healthProfile} />}
            {activeStep === 11 && <Page12 profile={healthProfile} />}
            {activeStep === 12 && <Page13 profile={healthProfile} />}
            <Box className={classes.footer}>
                <RepLIMobileStepper steps={steps} activeStep={activeStep}
                    onNextButtonClick={handleNextButtonClick}
                    onBackButtonClick={handleBackButtonClick}
                    onFinishButtonClick={handleFinishButtonClick}
                    onExitButtonClick={handleExitButtonClick}
                />
            </Box>
        </MobileRegularPage>
    )
};

export default withRouter(Questionary);